define('TescoMobile_Checkout/js/form/element/address-selector',['Magento_Ui/js/form/element/select', '../../model/no-addresses-listed-modal'], function (Component, noAddressModal) {
  'use strict';

  var checkoutConfig = window.checkoutConfig,
    addressLookupConfig = checkoutConfig && checkoutConfig.tescomobile && checkoutConfig.tescomobile.addressLookup ? checkoutConfig.tescomobile.addressLookup : {};
  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/form/element/address-selector',
      exports: {
        addressLine1: "${ $.provider }:${ $.customScope }.street.0",
        addressLine2: "${ $.provider }:${ $.customScope }.street.1",
        city: "${ $.provider }:${ $.customScope }.city",
        ptcAbsCode: "${ $.provider }:${ $.customScope }.tm_ptc_abs_code"
      },
      accordionItems: addressLookupConfig.accordionItems || [],
      hasAddresses: false,
      onlyOneAddress: false,
      addresses: [],
      buildingId: null,
      postcode: null
    },
    initialize: function () {
      this._super();
      this.value.subscribe(this.updateAddress.bind(this));
    },
    initObservable: function () {
      return this._super().observe(['city', 'addressLine1', 'addressLine2', 'ptcAbsCode', 'addresses', 'mappedAddresses', 'hasAddresses', 'onlyOneAddress', 'buildingId', 'postcode']);
    },
    initNoAddressModal: function (element) {
      noAddressModal.createModal(element);
    },
    openNoAddressModal: function () {
      noAddressModal.showModal();
    },
    closeNoAddressPopup: function () {
      noAddressModal.closeModal();
    },
    updateAddress: function (value) {
      const address = this.addresses()[value] || {};
      this.addressLine1(address.address_line1 || '');
      this.addressLine2(address.address_line2 || '');
      this.city(address.town || '');
      this.ptcAbsCode(address.ptc_abs_code || '');
      this.postcode(address.postcode || '');
      if (address.building_identifier) {
        this.buildingId(address.building_identifier);
      }
    },
    setAddresses: function (addresses) {
      if (!addresses) {
        return;
      }
      this.addresses(addresses);
      this.hasAddresses(addresses.length > 0);
      this.onlyOneAddress(addresses.length === 1);
      this.setOptions(addresses.map((address, index) => ({
        value: index,
        label: address.building_identifier + ',' + address.address_line1 + ',' + address.postcode
      })));
    },
    getFormatedAddressItem: function () {
      const address = this.addresses()[0] || {};
      let formatedAddress = '';
      formatedAddress += address.building_identifier ? address.building_identifier + ', ' : '';
      formatedAddress += address.address_line1 ? address.address_line1 + ', ' : '';
      formatedAddress += address.address_line2 ? address.address_line2 + ', ' : '';
      formatedAddress += address.postcode ? address.postcode : '';
      return formatedAddress;
    }
  });
});

